<template>
    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
        <el-col :xl="3" :lg="3" :md="19" :sm="19" :xs="19" style="line-height: 28px;text-align: right;margin-right: 10px;">
            动作：
        </el-col>
        <el-col :xl="4" :lg="4" :md="24" :sm="24" :xs="24">
            <el-cascader
                    v-model="actionForm.spaceId"
                    @change="spaceChange"
                    ref="sonSpace"
                    :options="spaceList"
                    change-on-select="true"
                    collapse-tags
                    filterable
                    placeholder="空间"
                    size="mini"
                    style="padding-bottom: 5px; width: 80%">
            </el-cascader>
        </el-col>
        <el-col :xl="4" :lg="4" :md="24" :sm="24" :xs="24">
            <el-select
                    v-model="actionForm.deviceId"
                    collapse-tags
                    @change="deviceChange"
                    ref="sonDevice"
                    placeholder="设备"
                    size="mini"
                    style="padding-bottom: 5px;width: 80%">
                <el-option
                        v-for="item in sonDeviceList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-col>
      <el-col :xl="4" :lg="4" :md="24" :sm="24" :xs="24" v-if="isDVR">
        <el-select
          v-model="actionForm.channel"
                   collapse-tags
                   placeholder="通道"
                   size="mini"
                   style="padding-bottom: 5px;width: 80%">
          <el-option
            v-for="item in channelList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
        <el-col :xl="4" :lg="4" :md="24" :sm="24" :xs="24">
            <div v-if="!isEquipment" style="margin-left:15px;margin-top: 3px;">画面联动</div>
            <el-select v-if="isEquipment"
                    v-model="actionForm.devicePointId"
                    collapse-tags
                    @change="pointChange"
                    placeholder="测点"
                    size="mini"
                    style="padding-bottom: 5px;width: 80%">
                <el-option
                        v-for="item in pointList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-col>
        <el-col :xl="4" :lg="4" :md="24" :sm="24" :xs="24">
            <el-select  v-if="isEquipment && isTextInput"
                    v-model="actionForm.deviceModelControlId"
                    @change="typeChange"
                    collapse-tags
                    placeholder="控制"
                    size="mini"
                    style="padding-bottom: 5px;width: 80%">
                <el-option
                        v-for="item in control"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-col>
        <el-col :xl="4" :lg="4" :md="24" :sm="24" :xs="24">
            <el-input v-if="type=='text'" class="inline-input" size="mini" placeholder="请输入值" style="width: 80%" v-model="actionForm.pointValue"></el-input>
        </el-col>
        <el-col :xl="2" :lg="2" :md="24" :sm="24" :xs="24">
            <el-button @touchstart="deleteList" @click="deleteList" size="mini" style="color: #07E6F8" v-if="index!=0"> -</el-button>
            <el-button size="mini" style="color: red" v-if="index==0" @touchstart="add" @click="add"> +</el-button>
        </el-col>
    </el-col>
</template>

<script>
import {getListBySpaceIdAndStatus} from "@/network/device-info";
import {getByModelIdFromDeviceId, pointNameDistinguish} from "@/network/device-measuring-point";
import {getByDeviceIdAndPointId, getByModelIdAndCode} from "@/network/device-model-control";
import {getDVRInfo} from "@/network/DVR";
import lodash from "lodash";

export default {
  name: "SonScene",
  props: {
    item: {
      type: Object,
      default: Object
    },
    index: {
      type: Number,
      required: true
    },
            deviceLinkageActions: {
                type: Array,
                default: Array
            },
            spaceList: {
                type: Array,
                default: Array
            }
        },
        created() {
            this.actionForm=lodash.cloneDeep(this.item);
            if(this.actionForm){
                this.getPointList(this.actionForm.deviceId);
                this.getDeviceList(this.actionForm.spaceId);
                // 根据设备和测点查找
                this.getByDeviceIdAndPointId(this.actionForm.deviceId,this.actionForm.devicePointId);
            }
        },
        data(){
            return {
                actionForm:{
                    isMatches:'',
                    spaceId:'',
                    spaceName:'',
                    deviceId:'',
                    deviceName:'',
                    deviceModelControlId:'',
                    gatewaySn:'',
                    channel:'',
                    devicePointId:'',
                    devicePointName:'',
                    pointValue:'',
                    // 设备类型
                    deviceType:''
                },
                isEquipment:true,
                isTextInput:true,
                isDVR:false,
                modelId:'',
                code:'',
                type:'',
                sonDeviceList:[
                    {value:'',label:'请选择设备'}
                ],
                pointList:[
                    {value:'',label:'可选测点'}
                ],
              // 通道列表
              channelList:[
              ],
                // 操控选项
                control:[],
            }
        },
        watch: {
            actionForm: {
                handler (newV) {
                    this.$emit('uploadData', {index: this.index,type: this.type, data: newV})
                },
                deep: true
            },
            deviceLinkageActions: {
                handler (newV) {
                    if (newV.length !== 0) {
                        this.actionForm = {...newV[this.index]}
                    }
                },
                deep: true
            }
        },
        methods:{
            typeChange(val){
                let type=this.control.filter(i => i.id == val)[0];
                this.type=type.type;
                if(this.type!='text'){
                    this.actionForm.pointValue=type.value;
                }
            },
            pointChange(val){
                this.isTextInput=true;
                let point=this.pointList.filter(i => i.id == val)[0];
                this.actionForm.devicePointName=point.name;
                this.actionForm.devicePointId=val;
                this.actionForm.deviceModelControlId='';
                this.actionForm.pointValue='';
                this.type='';
                this.code=point.code;
                this.getByModelIdAndCode();
            },
            getByDeviceIdAndPointId(deviceId,pointId){
                // 获取测点设置
                getByDeviceIdAndPointId(deviceId,pointId).then(res=>{
                    if(res.data){
                        this.control=res.data;
                        if(this.control!=undefined && this.control.length==1 && this.control[0].type=='text'){
                            // 保存
                            this.isTextInput=false;
                            let type=this.control[0];
                            this.actionForm.deviceModelControlId=type.id;
                            this.type=type.type;
                        }
                        this.typeChange(this.actionForm.deviceModelControlId);
                    }
                });
            },
            getByModelIdAndCode(){
                // 获取测点设置
                getByModelIdAndCode(this.modelId,this.code).then(res=>{
                    console.log(res);
                    if(res.data){
                        this.control=res.data;
                        if(this.control!=undefined && this.control.length==1 && this.control[0].type=='text'){
                            // 保存
                            this.isTextInput=false;
                            let type=this.control[0];
                            this.actionForm.deviceModelControlId=type.id;
                            this.type=type.type;
                        }
                    }
                });
            },
            deviceChange(val){
                if(val){
                    if(val.length>0){
                        this.actionForm.deviceId=val;
                        let device=this.sonDeviceList.filter(i => i.id == val)[0];
                        console.log("设备",device)
                        this.actionForm.deviceName=device.name;
                        this.actionForm.gatewaySn=device.gatewaySn;
                        this.modelId=device.modelId;
                        this.getPointList(this.actionForm.deviceId);
                        this.actionForm.devicePointId='';
                        this.actionForm.devicePointName='';
                        this.actionForm.deviceModelControlId='';
                        this.actionForm.channel='';
                        this.type='';
                        this.control=[];
                        this.actionForm.deviceType=device.typeEngName;
                        // 判断设备是否为摄像头或视频
                        if(device.typeEngName=='PM_Video' || device.typeEngName=='Video_vlc' || device.typeEngName=='PM_CAM'){
                            this.isEquipment=false;
                        }else{
                            this.isEquipment=true;
                        }
                      this.isDVR=false;
                      // 判断是否为硬盘录像机
                      if(device.typeEngName=='PM_DVR'){
                        this.getDVRInfo(device);
                        this.isEquipment=false;
                        this.isDVR=true;
                      }
                      // 若为硬盘录像机  查找他的通道 让用户选择
                    }
                }
            },
            spaceChange(val){
                if(val){
                    if(val.length>0){
                        this.actionForm.spaceId=val[val.length-1];
                        this.actionForm.spaceName=this.$refs['sonSpace'].getCheckedNodes()[0].data.label;
                        this.getDeviceList(this.actionForm.spaceId);
                        this.actionForm.deviceId='';
                        this.actionForm.deviceName='';
                        this.actionForm.devicePointId='';
                        this.actionForm.devicePointName='';
                        this.actionForm.deviceModelControlId='';
                        this.actionForm.channel='';
                        this.type='';
                        this.pointList=[];
                        this.control=[];
                    }
                }
            },
            deleteList: function () {
                this.$emit('deleteIndex', this.index);
            },
            add: function () {
                this.$emit('add')
            },
            getDeviceList(spaceInfo){
                getListBySpaceIdAndStatus(spaceInfo).then(res => {
                    this.sonDeviceList= res.data;
                    if(this.actionForm.deviceId){
                        let device=this.sonDeviceList.filter(i => i.id == this.actionForm.deviceId)[0];
                        // 判断设备是否为摄像头
                        if(device.typeEngName=='PM_Video' || device.typeEngName=='Video_vlc' || device.typeEngName=='PM_CAM'){
                            this.isEquipment=false;
                        }else{
                            this.isEquipment=true;
                        }
                      this.getDVRInfo(device);
                      this.isDVR=false;
                      // 判断是否为硬盘录像机
                      if(device.typeEngName=='PM_DVR'){
                        this.isEquipment=false;
                        this.isDVR=true;
                      }
                        this.modelId=device.modelId;
                        this.actionForm.deviceType=device.typeEngName;
                    }
                });
            },
            getPointList(deviceId){
                getByModelIdFromDeviceId(deviceId).then(res=>{
                    if (res.data) {
                        this.pointList= pointNameDistinguish(res.data,this.actionForm.deviceType);
                    }
                });
            },
          //获取视频通道信息
          getDVRInfo(device) {
            if (device.portProperties) {
              let properties = JSON.parse(device.portProperties);
              console.log(properties);
              getDVRInfo("hikvision", properties.User, properties.pwd, properties.IP).then(res => {
                console.log("视频信息参数", res.code);
                if (res.code === 0) {
                  const chanNum = res.data.chanNum;
                  const startChan = res.data.startChan;
                  // const dwDChanNum = res.data.dwDChanNum
                  // const dwStartDChan = res.data.dwStartDChan
                  const dvrDeviceChanInfos = res.data.dvrDeviceChanInfos;
                  this.channelList = [];
                  if (chanNum && chanNum > 0) {
                    for (let i = startChan; i < startChan + chanNum; i++) {
                      this.channelList.push({id:i+"",name:'通道'+i});
                    }
                  }
                  if (dvrDeviceChanInfos && dvrDeviceChanInfos.length > 0) {
                    dvrDeviceChanInfos.forEach(item => {
                      if (item.byChannel !== 0) {
                        this.channelList.push({id:item.byIPID+"",name:'通道'+item.byIPID});
                      }
                    })
                  }
                  console.log(this.channelList, "=====this.channelList======");
                }
              })
            }
          },
        }
    }
</script>

<style scoped>

</style>
